import {createMuiTheme} from '@material-ui/core/styles';
import {grey} from '@material-ui/core/colors';
import createPalette from '@material-ui/core/styles/createPalette';

const darkPalette = createPalette({
    type: 'dark', // Switching the dark mode on is a single property value change.
    primary: {
        main: 'rgba(39,100,123,0.9)',
    },
    secondary: {
        light: '#008755',
        main: 'rgba(39,100,123,0.9)',
        dark: 'rgba(39,100,123,0.9)',
        contrastText: '#fff',
    }
});

export const getThemes = (
    theme
) => {
    return {darkTheme: darkTheme(theme), lightTheme: lightTheme(theme)};
};

export const darkTheme = (theme) => ({
    palette: darkPalette,
    shape: {
        // borderRadius: 10,
    },
    spacing: 8,
    overrides: {
        RaAppBar: {
            menuButton: {
                // Since sub-<Menu /> hide labels when sidebar is closed
                // We need to disallow sidebar closing (hiding button is simpler)
                // display: 'none',

            },
        },
        RaMenuItemLink: {
            root: {
                borderLeft: '3px solid #fff',
            },
            active: {
                borderLeft: '3px solid #808080',
                color: 'black',
                backgroundColor: grey[200]

            },
        },
        RaMenuItemCategory: {
            root: {
                color: '#808080',
                '&:hover': {
                    color: 'black',
                    backgroundColor: grey[200],
                },
                active: {
                    color: 'black',
                    backgroundColor: grey[200],
                },
            },
        },
        RaMenuItem: {
            root: {
                color: '#808080',
            },
            active: {
                color: 'rgba(39,100,123,0.9)',
                backgroundColor: grey[200],
            },

        },
        RaMultiLevelMenu: {
            navWithCategories: {
                backgroundColor: '#fff',
            },
        },
        MuiPaper: {
            elevation1: {
                boxShadow: 'none',
            },
            root: {
                border: '1px solid #e0e0e3',
                backgroundClip: 'padding-box',
            },
        },
        MuiButton: {
            root: {
                minWidth: 0,
            },

            contained: {

                backgroundColor: '#fff',
                color: '#008755',
                boxShadow: 'none',
            },
        },
        MuiAppBar: {
            // Hide MenuItemCategory shadow behind the appbar
            root: {zIndex: 9999},
            colorSecondary: {},
        },
        MuiLinearProgress: {
            colorPrimary: {
                backgroundColor: '#f5f5f5',
            },
            barColorPrimary: {
                backgroundColor: '#d7d7d7',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        /* RaSidebar: {
             drawerPaper: {
                 paddingRight: 16,
                 width: 'auto',
             },
         },*/
        RaFilterFormInput: {
            body: {
                // Fixes search filter breadcrumb overlap
                '& > div': {
                    marginTop: 8,
                },
            },
        },
        RaLinkedData: {
            root: {
                '&:hover': {
                    backgroundColor: '#ddd',
                },
            },
        },
        RaTopToolbar: {
            root: {
                alignItems: 'center',
                paddingTop: 0,
                minHeight: 'auto',
            },
        },
        RaFilter: {
            form: {
                minHeight: 0,
                marginTop: 0,
            }
        },
        RaListToolbar: {
            /*root: {
                alignItems: 'center',
                paddingTop: 0,
            },*/
            actions: {
                alignItems: 'center',
                minHeight: 'auto',
                paddingTop: 0,
            },
            toolbar: {
                minHeight: 'auto',
            },
        },
        MuiAccordion: {
            root: {
                border: '1px solid rgba(0, 0, 0, .125)',
                boxShadow: 'none',
                '&:not(:last-child)': {
                    borderBottom: 0,
                },
                '&:before': {
                    display: 'none',
                },
                '&$expanded': {
                    margin: 'auto',
                },
            },
            expanded: {},
        },
        MuiAccordionSummary: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.13)',
                borderBottom: '1px solid rgba(0, 0, 0, .125)',
                marginBottom: -1,
                minHeight: 56,
                '&$expanded': {
                    minHeight: 56,
                },
            },
            content: {
                '&$expanded': {
                    margin: '12px 0',
                },
            },
            expanded: {},
        },
        MuiAccordionDetails: {
            root: {
                padding: 20,
            },
        },
        /* RaDatagrid: {
             headerCell: {
                 backgroundColor: '#ebebeb',
             }
         }*/
        MuiButtonBase: {
            root: {
                '&:hover': {
                    color: 'rgba(39,100,123,0.9)',
                    backgroundColor: grey[200],
                },
            },
        }
    },
});

const lightPalette = createPalette({
    type: 'light',
    primary: {
        main: 'rgba(39,100,123,0.9)',
    },
    secondary: {
        light: '#008755',
        main: 'rgba(39,100,123,0.9)',
        dark: 'rgba(39,100,123,0.9)',
        contrastText: '#fff',
    },
    background: {
        default: '#fcfcfe',
    },
});

export const lightTheme = (theme) => createMuiTheme({
    palette: lightPalette,
    shape: {
        // borderRadius: 10,
    },
    spacing: 8,
    overrides: {
        RaAppBar: {
            menuButton: {
                // Since sub-<Menu /> hide labels when sidebar is closed
                // We need to disallow sidebar closing (hiding button is simpler)
                // display: 'none',

            },
        },
        RaMenuItemLink: {
            root: {
                borderLeft: '3px solid #fff',
            },
            active: {
                borderLeft: '3px solid #808080',
                color: 'black',
                backgroundColor: grey[200]

            },
        },
        RaMenuItemCategory: {
            root: {
                color: '#808080',
                '&:hover': {
                    color: 'black',
                    backgroundColor: grey[200],
                },
                active: {
                    color: 'black',
                    backgroundColor: grey[200],
                },
            },
        },
        RaMenuItem: {
            root: {
                color: '#808080',
            },
            active: {
                color: 'rgba(39,100,123,0.9)',
                backgroundColor: grey[200],
            },

        },
        RaMultiLevelMenu: {
            navWithCategories: {
                backgroundColor: '#fff',
            },
        },
        MuiPaper: {
            elevation1: {
                boxShadow: 'none',
            },
            root: {
                border: '1px solid #e0e0e3',
                backgroundClip: 'padding-box',
            },
        },
        MuiButton: {
            root: {
                minWidth: 0,
            },

            contained: {

                backgroundColor: '#fff',
                color: '#008755',
                boxShadow: 'none',
            },
        },
        MuiAppBar: {
            // Hide MenuItemCategory shadow behind the appbar
            root: {zIndex: 9999},
            colorSecondary: {},
        },
        MuiLinearProgress: {
            colorPrimary: {
                backgroundColor: '#f5f5f5',
            },
            barColorPrimary: {
                backgroundColor: '#d7d7d7',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        /* RaSidebar: {
             drawerPaper: {
                 paddingRight: 16,
                 width: 'auto',
             },
         },*/
        RaFilterFormInput: {
            body: {
                // Fixes search filter breadcrumb overlap
                '& > div': {
                    marginTop: 8,
                },
            },
        },
        RaLinkedData: {
            root: {
                '&:hover': {
                    backgroundColor: '#ddd',
                },
            },
        },
        RaTopToolbar: {
            root: {
                alignItems: 'center',
                paddingTop: 0,
                minHeight: 'auto',
            },
        },
        RaFilter: {
            form: {
                minHeight: 0,
                marginTop: 0,
            }
        },
        RaListToolbar: {
            /*root: {
                alignItems: 'center',
                paddingTop: 0,
            },*/
            actions: {
                alignItems: 'center',
                minHeight: 'auto',
                paddingTop: 0,
            },
            toolbar: {
                minHeight: 'auto',
            },
        },
        MuiAccordion: {
            root: {
                border: '1px solid rgba(0, 0, 0, .125)',
                boxShadow: 'none',
                '&:not(:last-child)': {
                    borderBottom: 0,
                },
                '&:before': {
                    display: 'none',
                },
                '&$expanded': {
                    margin: 'auto',
                },
            },
            expanded: {},
        },
        MuiAccordionSummary: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.13)',
                borderBottom: '1px solid rgba(0, 0, 0, .125)',
                marginBottom: -1,
                minHeight: 56,
                '&$expanded': {
                    minHeight: 56,
                },
            },
            content: {
                '&$expanded': {
                    margin: '12px 0',
                },
            },
            expanded: {},
        },
        MuiAccordionDetails: {
            root: {
                padding: 20,
            },
        },
        /* RaDatagrid: {
             headerCell: {
                 backgroundColor: '#ebebeb',
             }
         }*/
        MuiButtonBase: {
            root: {
                '&:hover': {
                    color: 'rgba(39,100,123,0.9)',
                    backgroundColor: grey[200],
                },
            },
        }
    },
});